import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import DebouncedButton from "./DebounceButton";
import React from "react";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  content: string;
  buttonColor?: string;
}

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  content,
  buttonColor,
}: ConfirmDialogProps) => {
  const renderContentWithBold = (text: string) => {
    const parts = text.split("**");
    return parts.map((part, index) => {
      if (index % 2 === 1) {
        return <strong key={index}>{part}</strong>;
      } else {
        return <React.Fragment key={index}>{part}</React.Fragment>;
      }
    });
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography component="div" sx={{ whiteSpace: "pre-line" }}>
          {renderContentWithBold(content)}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <DebouncedButton
          variant="contained"
          onClick={() => {
            onConfirm(); // Execute the confirm callback
            onClose(); // Close the dialog
          }}
          color="error"
          sx={{
            backgroundColor: buttonColor ?? "#d32f2f",
            color: "#FFF",
          }}
        >
          Confirm
        </DebouncedButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
